import { CTimePicker } from './CTimePicker.js';

const CTimePickerPlugin = {
    install: (app) => {
        app.component(CTimePicker.name, CTimePicker);
    },
};

export { CTimePicker, CTimePickerPlugin };
//# sourceMappingURL=index.js.map
